export enum Etapa {
    Aberto = 0,
    Fechado = 1
}